module.exports = __webpack_public_path__ + "img/P150T_weapon_144.993cb1ee.png";